/*
 * Variante C Marketplace: Hero-Slider, Produktreihen, Suche mit Vorschlägen, Routinen, Schnell-in-den-Warenkorb.
 * Kein Framework. Warenkorb: meldet jedes Hinzufügen über Horizons Standard-Event (shopify:cart:lines-update),
 * damit Drawer, Zähler und Versandbalken von Horizon selbst aktualisiert werden, und öffnet danach den Drawer.
 * Fällt ohne Horizon-Module auf Toast + Link zum Warenkorb zurück.
 */
(function () {
  var isRtl = document.documentElement.dir === 'rtl';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Geldbetrag im Shop-Format, z. B. "{{amount_with_comma_separator}} €" -> "12,99 €" */
  function money(cents, format) {
    format = format || '{{amount_with_comma_separator}} €';
    var n = Math.round(Number(cents) || 0);
    function grp(v, dec, th, sep) {
      var parts = (v / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return grp(n, 2, ',', '.');
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return grp(n, 2, "'", '.');
      return grp(n, 2, '.', ',');
    });
  }

  /* ---------------- Hero-Slider ---------------- */
  function initSlider(el) {
    if (el.dataset.mpInit) return;
    el.dataset.mpInit = '1';
    var slides = el.querySelectorAll('.mp-slide');
    var dots = el.querySelectorAll('.mp-dot');
    if (slides.length < 2) return;
    var i = 0;
    var timer = null;
    var hold = { hover: false, focus: false, hidden: false, off: false };
    var delay = (parseInt(el.dataset.delay, 10) || 6) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (reduceMotion || hold.hover || hold.focus || hold.hidden || hold.off) return;
      timer = setInterval(function () { go(i + 1); }, delay);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var prev = el.querySelector('.mp-arrow--prev');
    var next = el.querySelector('.mp-arrow--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    el.addEventListener('mouseenter', function () { hold.hover = true; stop(); });
    el.addEventListener('mouseleave', function () { hold.hover = false; play(); });
    el.addEventListener('focusin', function () { hold.focus = true; stop(); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { hold.focus = false; play(); } });
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var fwd = (e.key === 'ArrowRight') !== isRtl;
      go(i + (fwd ? 1 : -1));
    });
    document.addEventListener('visibilitychange', function () { hold.hidden = document.hidden; play(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { hold.off = !en[0].isIntersecting; play(); }, { threshold: 0.2 }).observe(el);
    }
    /* Wischen: nur waagerechte Gesten, senkrechtes Scrollen bleibt frei. Pause, solange der Finger liegt. */
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; hold.hover = true; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      hold.hover = false;
      if (x0 !== null) {
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          go(i + ((dx < 0) !== isRtl ? 1 : -1));
          el.dataset.swiped = '1';
          setTimeout(function () { delete el.dataset.swiped; }, 350);
        }
      }
      x0 = y0 = null;
      play();
    });
    /* Nach einer Wischgeste keinen Link öffnen */
    el.addEventListener('click', function (e) { if (el.dataset.swiped && e.target.closest('.mp-slide')) e.preventDefault(); }, true);
    go(0);
    play();
  }

  /* ---------------- Produktreihen ---------------- */
  function initRail(el) {
    if (el.dataset.mpInit) return;
    el.dataset.mpInit = '1';
    var track = el.querySelector('.mp-rail__track');
    var prev = el.querySelector('.mp-rail__nav--prev');
    var next = el.querySelector('.mp-rail__nav--next');
    if (!track || !prev || !next) return;
    function pos() { return Math.abs(track.scrollLeft); }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = pos() <= 2;
      next.disabled = pos() >= max;
    }
    function move(dir) {
      var step = track.clientWidth * 0.9 * dir;
      track.scrollBy({ left: isRtl ? -step : step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Warenkorb-Fehlertext: für fa/ar die Theme-Meldung statt Shopifys deutscher Meldung */
  function cartErr(msg) {
    if (typeof Theme !== 'undefined' && typeof Theme.cartErrorText === 'function') return Theme.cartErrorText(msg);
    return msg || 'Error';
  }

  /* ---------------- Toast (Rückfall) ---------------- */
  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mp-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  function updateBubble(count) {
    var icon = document.querySelector('cart-icon');
    try {
      if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count);
    } catch (e) { /* Horizon-Interna geändert: Zähler stimmt beim nächsten Seitenaufruf */ }
  }

  /* ---------------- Warenkorb: mehrere Artikel hinzufügen ---------------- */
  var eventsModule = null;
  function loadEvents() {
    if (eventsModule) return eventsModule;
    try {
      eventsModule = import('@shopify/events').catch(function () { return null; });
    } catch (e) {
      eventsModule = Promise.resolve(null);
    }
    return eventsModule;
  }

  /* Öffnet den Warenkorb-Drawer. Horizon öffnet ihn selbst, wenn „Warenkorb automatisch öffnen“ aktiv ist;
     sonst (oder falls das ausbleibt) öffnen wir ihn hier, nachdem Horizon den Inhalt neu gerendert hat. */
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return false;
    function tryOpen() {
      try {
        if (typeof d.open === 'function' && !d.isOpen && !d.hasAttribute('open')) d.open();
      } catch (e) { /* ignore */ }
    }
    if (typeof d.open !== 'function' && !(window.customElements && customElements.get('theme-drawer'))) return false;
    requestAnimationFrame(tryOpen);
    setTimeout(tryOpen, 400);
    return true;
  }

  /**
   * @param {{id: string|number, quantity: number}[]} items
   * @param {Element} source - Element, an dem das Event startet (Formular/Button)
   * @returns {Promise<object>} Warenkorb (cart.js)
   */
  function addToCart(items, source) {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      if (ids.indexOf(c.dataset.sectionId) < 0) ids.push(c.dataset.sectionId);
    });
    var qty = items.reduce(function (a, b) { return a + (Number(b.quantity) || 1); }, 0);

    return loadEvents().then(function (ev) {
      var deferred = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          deferred = ev.CartLinesUpdateEvent.createPromise();
          source.dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: Number(it.quantity) || 1 }; }),
            promise: deferred.promise
          }));
        } catch (e) { deferred = null; }
      }
      var body = { items: items.map(function (it) { return { id: Number(it.id), quantity: Number(it.quantity) || 1 }; }) };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
      var added;
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var er = new Error(j.description || j.message || 'add'); er.data = j; throw er; } return j; }); })
        .then(function (j) { added = j; return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (deferred) {
            deferred.resolve({
              cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'mp', itemCount: qty, sections: added && added.sections, didError: false }
            });
          } else {
            updateBubble(cart.item_count);
          }
          return { cart: cart, drawer: !!deferred && openDrawer() };
        })
        .catch(function (err) {
          if (deferred) {
            fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'mp', itemCount: 0 } });
            }).catch(function () { deferred.reject(err); });
          }
          throw err;
        });
    });
  }

  /* Produktkarte: "In den Warenkorb" */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.mp-card__form')) return;
    if (!window.fetch || !window.Promise) return;
    e.preventDefault();
    var btn = form.querySelector('.mp-card__add');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    addToCart([{ id: fd.get('id'), quantity: fd.get('quantity') || 1 }], form)
      .then(function (res) {
        if (btn) { btn.classList.add('is-done'); btn.textContent = form.dataset.done || 'OK'; }
        if (!res.drawer) showToast('<span>' + esc(form.dataset.done) + '</span><a href="' + root + 'cart">' + esc(form.dataset.cart || 'Cart') + '</a>');
        setTimeout(function () { if (btn) { btn.classList.remove('is-done'); btn.innerHTML = label; } }, 2200);
      })
      .catch(function (err) {
        if (err && err.data && err.data.description) showToast('<span>' + esc(cartErr(err.data.description)) + '</span>');
        else form.submit();
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------------- Routinen: Reiter + alle in den Warenkorb ---------------- */
  function initRoutines(el) {
    if (el.dataset.mpInit) return;
    el.dataset.mpInit = '1';
    var tabs = Array.prototype.slice.call(el.querySelectorAll('.mp-pill'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var d = 0;
        if (e.key === 'ArrowRight') d = isRtl ? -1 : 1;
        if (e.key === 'ArrowLeft') d = isRtl ? 1 : -1;
        if (e.key === 'Home') { e.preventDefault(); return select(tabs[0], true); }
        if (e.key === 'End') { e.preventDefault(); return select(tabs[tabs.length - 1], true); }
        if (!d) return;
        e.preventDefault();
        select(tabs[(k + d + tabs.length) % tabs.length], true);
      });
    });

    var fmt = el.dataset.money;
    var threshold = Number(el.dataset.threshold) || 0;
    el.querySelectorAll('.mp-routine').forEach(function (panel) {
      var boxes = Array.prototype.slice.call(panel.querySelectorAll('.mp-rstep input[type="checkbox"]'));
      var btn = panel.querySelector('[data-add]');
      var lbl = panel.querySelector('[data-add-label]');
      var sumEl = panel.querySelector('[data-sum]');
      var note = panel.querySelector('[data-note]');
      if (!btn) return;
      var avail = boxes.filter(function (b) { return !b.disabled; }).length;
      function refresh() {
        var on = boxes.filter(function (b) { return b.checked && !b.disabled; });
        var sum = on.reduce(function (a, b) { return a + Number(b.dataset.price || 0); }, 0);
        if (sumEl) sumEl.innerHTML = '<bdi>' + esc(money(sum, fmt)) + '</bdi>';
        if (note) note.hidden = !(threshold && sum >= threshold);
        btn.disabled = on.length === 0;
        if (lbl) {
          var t = on.length === 0 ? el.dataset.lNone : (on.length === avail ? el.dataset.lAll : el.dataset.lSome);
          lbl.textContent = (t || '').replace('__N__', on.length);
        }
      }
      boxes.forEach(function (b) { b.addEventListener('change', refresh); });
      refresh();
      btn.addEventListener('click', function () {
        var items = boxes.filter(function (b) { return b.checked && !b.disabled; }).map(function (b) { return { id: b.dataset.variant, quantity: 1 }; });
        if (!items.length) return;
        var keep = lbl ? lbl.textContent : '';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        addToCart(items, btn)
          .then(function (res) {
            if (lbl) lbl.textContent = el.dataset.done || 'OK';
            if (!res.drawer) showToast('<span>' + esc(el.dataset.done) + '</span><a href="' + root + 'cart">' + esc(document.querySelector('.mp-card__form') ? document.querySelector('.mp-card__form').dataset.cart : 'Cart') + '</a>');
            setTimeout(function () { if (lbl) lbl.textContent = keep; }, 2200);
          })
          .catch(function (err) { showToast('<span>' + esc(cartErr(err && err.data && err.data.description)) + '</span>'); })
          .finally(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* ---------------- Header-Suche mit Vorschlägen (Shopify Predictive Search API) ---------------- */
  function initSearch(form) {
    if (form.dataset.mpInit) return;
    form.dataset.mpInit = '1';
    var input = form.querySelector('.mp-hsearch__input');
    var pop = form.querySelector('.mp-hsearch__pop');
    if (!input || !pop || !window.fetch) return;
    var url = form.dataset.url || root + 'search/suggest';
    /* Shopify Predictive Search kennt nicht jede Sprache (fa/ar: 417 „Unsupported buyer locale“).
       Dann keine Vorschläge: das Formular schickt wie ohne JavaScript an die normale Suchseite (/fa/search?q=). */
    var predictive = document.documentElement.dataset.predictive !== 'off';
    var fmt = form.dataset.money;
    var ctrl = null, t = null, last = '', active = -1;

    function opts() { return Array.prototype.slice.call(pop.querySelectorAll('[role="option"]')); }
    function close() {
      pop.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function open() {
      pop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (window.innerWidth < 750) {
        var r = form.getBoundingClientRect();
        pop.style.top = Math.round(r.bottom + 6) + 'px';
      } else {
        pop.style.top = '';
      }
    }
    function mark(n) {
      var o = opts();
      if (!o.length) return;
      active = (n + o.length) % o.length;
      o.forEach(function (x, k) { x.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', o[active].id);
      o[active].scrollIntoView({ block: 'nearest' });
    }
    function cents(v) { return Math.round(parseFloat(String(v || '0').replace(',', '.')) * 100); }
    function img(src) {
      if (!src) return '<span class="mp-hsearch__ph" aria-hidden="true"></span>';
      var s = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      return '<img src="' + esc(s) + '" alt="" width="48" height="48" loading="lazy">';
    }
    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var prods = res.products || [];
      var cols = res.collections || [];
      var html = '';
      var n = 0;
      if (prods.length) {
        html += '<p class="mp-hsearch__h">' + esc(form.dataset.lProducts) + '</p>';
        prods.forEach(function (p) {
          var price = cents(p.price);
          var was = cents(p.compare_at_price_max);
          html += '<a class="mp-hsearch__opt" role="option" aria-selected="false" id="mp-hs-' + n++ + '" href="' + esc(p.url) + '">' + img(p.image || (p.featured_image && p.featured_image.url)) +
            '<span><span class="mp-hsearch__vendor">' + esc(p.vendor) + '</span><span class="mp-hsearch__name">' + esc(p.title) + '</span></span>' +
            '<span class="mp-hsearch__price">' + esc(money(price, fmt)) + (was > price ? '<s>' + esc(money(was, fmt)) + '</s>' : '') + '</span></a>';
        });
      }
      if (cols.length) {
        html += '<p class="mp-hsearch__h">' + esc(form.dataset.lCollections) + '</p>';
        cols.forEach(function (c) {
          html += '<a class="mp-hsearch__opt mp-hsearch__opt--text" role="option" aria-selected="false" id="mp-hs-' + n++ + '" href="' + esc(c.url) + '"><span class="mp-hsearch__name">' + esc(c.title) + '</span></a>';
        });
      }
      if (!n) html += '<p class="mp-hsearch__none">' + esc(form.dataset.lNone) + '</p>';
      html += '<a class="mp-hsearch__all" role="option" aria-selected="false" id="mp-hs-' + n + '" href="' + esc(form.getAttribute('action')) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(form.dataset.lAll) + '</a>';
      pop.innerHTML = html;
      active = -1;
      open();
    }
    function query() {
      if (!predictive) return;
      var q = input.value.trim();
      if (q.length < 2) { close(); last = ''; return; }
      if (q === last && !pop.hidden) return;
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var u = url + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,variants.title,tag';
      fetch(u, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 417 || r.status === 400) { predictive = false; }
          if (!r.ok) throw new Error('suggest');
          return r.json();
        })
        .then(function (d) { if (input.value.trim() === q) render(q, d); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') close(); });
    }
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(query, 180); });
    input.addEventListener('focus', function () { if (pop.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (pop.hidden) query(); else mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Escape') { if (!pop.hidden) { e.preventDefault(); close(); } }
      else if (e.key === 'Enter' && active > -1 && !pop.hidden) { var o = opts()[active]; if (o) { e.preventDefault(); window.location.href = o.href; } }
    });
    document.addEventListener('pointerdown', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('focusout', function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) close(); });
    window.addEventListener('resize', function () { if (!pop.hidden) open(); });
  }

  /* ---------------- RTL: Absätze ganz ohne persische/arabische Schrift (z. B. deutsche Seitentexte auf /fa)
     bekommen dir="auto", damit Punkt, Fragezeichen und Klammern nicht an den Zeilenanfang springen.
     Gemischte Absätze bleiben RTL. Gilt für Seiten-, Richtlinien- und Textblöcke, nicht für Produktkarten. */
  var ARABIC = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  var LATIN = /[A-Za-zÀ-ÿ]/;
  function fixBidi(scope) {
    if (!isRtl) return;
    var sel = ':is(.rte, .page-content, .shopify-policy__container, .text-block) :is(p, li, h1, h2, h3, h4, h5, h6, dt, dd, blockquote, figcaption, td, th)';
    var list;
    try { list = (scope || document).querySelectorAll('main ' + sel + ', .shopify-policy__container :is(h1, p, li, h2, h3, td, th)'); } catch (e) { return; }
    list.forEach(function (el) {
      if (el.hasAttribute('dir') || el.closest('.mp-card, product-card, .product-card')) return;
      var t = el.textContent || '';
      if (LATIN.test(t) && !ARABIC.test(t)) el.setAttribute('dir', 'auto');
    });
  }

  /* ---------------- Hauptmenü-Dropdown (v4): Liste direkt unter den Menüpunkt setzen.
     Die Liste bleibt im selben Bezugsrahmen wie das Mega-Menü (ausserhalb der überlaufenden Leiste),
     darum wird nur der Abstand zum Menüpunkt gemessen und ausgeglichen. In RTL rechtsbündig. */
  function placeDropdown(li) {
    if (!li || li.slot === 'overflow') return;
    var sm = li.querySelector(':scope > .phx-dd');
    if (!sm || window.innerWidth < 750) return;
    var anchor = li.querySelector('.menu-list__trigger') || li;
    var cs = getComputedStyle(sm);
    var a = anchor.getBoundingClientRect();
    var r = sm.getBoundingClientRect();
    var row = li.closest('.header__row');
    var bottom = (row || li).getBoundingClientRect().bottom - 1;
    var top = (parseFloat(cs.top) || 0) + (bottom - r.top);
    var x = isRtl ? (parseFloat(cs.right) || 0) + (r.right - a.right) : (parseFloat(cs.left) || 0) + (a.left - r.left);
    sm.style.setProperty('top', Math.round(top) + 'px');
    sm.style.setProperty('inset-inline-start', Math.round(x) + 'px');
  }
  function initDropdowns(scope) {
    (scope || document).querySelectorAll('.phx-dd-item').forEach(function (li) {
      if (li.dataset.phxDd) return;
      li.dataset.phxDd = '1';
      ['pointerenter', 'focusin', 'click'].forEach(function (ev) {
        li.addEventListener(ev, function () { placeDropdown(li); }, true);
      });
    });
  }
  /* Maus: Hover öffnet die Liste schon. Ein Mausklick auf den Pfeil darf sie dann nicht wieder zuklappen
     (header-menu.js toggle). Tastatur (detail 0) und Touch behalten das Umschalten. Klick ausserhalb und
     Escape schliessen über die öffentliche deactivate()-Methode bzw. den Escape-Handler von header-menu. */
  var ddPointer = '';
  document.addEventListener('pointerdown', function (e) { ddPointer = e.pointerType || ''; }, true);
  /* window statt document: component.js hört selbst per capture auf document und käme sonst zuerst. */
  window.addEventListener('click', function (e) {
    var btn = e.target instanceof Element && e.target.closest('.phx-dd-item .menu-list__disclosure');
    if (!btn || btn.getAttribute('aria-expanded') !== 'true' || e.detail === 0) return;
    var type = e.pointerType || ddPointer;
    if (type === 'mouse' || type === 'pen') { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);
  function openDd() {
    var btn = document.querySelector('.phx-dd-item .menu-list__disclosure[aria-expanded="true"]');
    return btn ? { btn: btn, menu: btn.closest('header-menu') } : null;
  }
  document.addEventListener('pointerdown', function (e) {
    var o = openDd();
    if (!o || !o.menu || (e.target instanceof Element && e.target.closest('.phx-dd-item'))) return;
    if (typeof o.menu.deactivate === 'function') o.menu.deactivate({ target: document.body, relatedTarget: null, type: 'pointerdown' });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var o = openDd();
    if (!o || !o.menu || o.menu.contains(e.target)) return;
    o.menu.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: false }));
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.phx-dd-item .phx-dd').forEach(function (sm) { sm.style.removeProperty('top'); sm.style.removeProperty('inset-inline-start'); });
  });

  function boot(scope) {
    var s = scope || document;
    initDropdowns(s);
    fixBidi(s);
    s.querySelectorAll('[data-mp-slider]').forEach(initSlider);
    s.querySelectorAll('[data-mp-rail]').forEach(initRail);
    s.querySelectorAll('[data-mp-routines]').forEach(initRoutines);
    s.querySelectorAll('[data-mp-search]').forEach(initSearch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
